/**
 * Estrae il claim `sub` da un JWT, senza validarne firma o scadenza: serve SOLO a confrontare
 * l'identità del token corrente con quella registrata su un elemento in coda (CORREZIONI-GIRO-2,
 * "Mobile", punto 2 — "Identità": ogni elemento ricorda il `sub` presente quando è stato generato,
 * e al flush si invia con `Authorization` solo se coincide con quello del token corrente, per non
 * attribuire a un utente B un errore generato da A). Stesso pattern di decodifica già in uso in
 * `TokenExpiryService.decodeExp`.
 */
export function decodeJwtSub(token: string | null | undefined): string | null {
  if (!token) {
    return null;
  }
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return typeof decoded?.sub === 'string' ? decoded.sub : null;
  } catch {
    return null;
  }
}
